<template>
    <div>
<input type="text">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>